const A = "https://customer-assets-lqy194kg.emergentagent.net/job_community-first-28/artifacts";

export const IMG = {
  hero: `${A}/buallejl_1785441481891.jpeg`,
  coast: "/site/ecl.webp",
  youth: "/site/youth.webp",
  boardroom: "/site/weekender2.webp",
  boardroom2: "/site/community.jpg",
  volunteersElderly: `${A}/tmqaqzrb_pride%20by%20the%20harbourside.webp`,
  volunteersDonate: `${A}/29ax1r7j_other%20events.webp`,
  meeting: "/site/weekender-crowd.webp",
  community: "/site/community.jpg",
  // real project photography
  yaz: `${A}/wg9odexq_yaz%20by%20nead.webp`,
  weekender: "/site/weekender-crowd.webp",
  pride: `${A}/tmqaqzrb_pride%20by%20the%20harbourside.webp`,
  energyCoast: "/site/ecl.webp",
  otherEvents: `${A}/29ax1r7j_other%20events.webp`,
  outreach: "/site/youth.webp",
};

export const STATS = [
  { value: 40000, suffix: "+", label: "People engaged every year" },
  { value: 120, suffix: "+", label: "Community projects delivered" },
  { value: 25, suffix: "+", label: "Active regional partnerships" },
  { value: 100, suffix: "%", label: "Of surplus reinvested locally" },
];

export const VALUES = [
  { n: "01", title: "Equality & inclusion", body: "We design services that reflect and serve the full diversity of our communities, removing barriers to participation and opportunity." },
  { n: "02", title: "Rooted in Cumbria", body: "Every programme responds to genuine local need, shaped in partnership with the people and places we serve." },
  { n: "03", title: "Opportunity for young people", body: "We create pathways into learning, volunteering and employment, giving the next generation a real stake in their communities." },
  { n: "04", title: "Sustainable by design", body: "Strong governance and responsible financial management mean the value we create endures well beyond any single project." },
];

export const PROJECTS = [
  {
    id: "yaz",
    n: "01",
    tag: "Youth provision",
    title: "YAZ, Young Adults' Zone",
    desc: "Cumbria's first dedicated social venue for under-18s: a safe, supervised space to socialise and thrive.",
    image: IMG.yaz,
    link: "/yaz",
    coming: true,
    body: [
      "YAZ is Cumbria's first dedicated social venue for young people under 18, providing a safe, welcoming and fully supervised environment where young people can socialise, develop confidence and access positive opportunities.",
      "The venue combines a café, gaming zone, entertainment space and regular activities, including monthly supervised rave nights, helping reduce anti-social behaviour while promoting wellbeing, inclusion and youth development.",
    ],
  },
  {
    id: "whitehaven-weekender",
    n: "02",
    tag: "Festival",
    title: "Whitehaven Weekender",
    desc: "A large-scale, multi-day community festival celebrating music, arts, culture and local talent.",
    image: IMG.weekender,
    link: "/ww",
    body: [
      "Whitehaven Weekender is a large-scale, multi-day community festival celebrating music, arts, culture and local talent. Bringing together thousands of residents and visitors, the festival showcases live entertainment, family activities, food, markets and community organisations.",
      "It supports tourism, boosts the local economy and creates opportunities for local businesses and performers across the region.",
    ],
  },
  {
    id: "pride-harbourside",
    n: "03",
    tag: "Equality & inclusion",
    title: "Pride by the Harbourside",
    desc: "One of Cumbria's leading LGBTQ+ celebrations, promoting equality, diversity and inclusion.",
    image: IMG.pride,
    link: "/pride",
    body: [
      "Pride by the Harbourside is one of Cumbria's leading LGBTQ+ celebrations, promoting equality, diversity and inclusion through live entertainment, community engagement and education.",
      "The event has grown into a landmark celebration that brings together thousands of people from across the region, and has since evolved into the wider Whitehaven Weekender festival.",
    ],
  },
  {
    id: "energy-coast-live",
    n: "04",
    tag: "Live music",
    title: "Energy Coast LIVE!",
    desc: "A major live music event attracting nationally recognised artists alongside local performers.",
    image: IMG.energyCoast,
    link: "/ecl",
    body: [
      "Energy Coast LIVE! is a major live music and entertainment event that attracts nationally recognised artists alongside local performers. Designed to celebrate Cumbria's vibrant culture while increasing visitor numbers, the event contributes significantly to the local economy.",
      "It provides valuable opportunities for local businesses, volunteers and community organisations.",
    ],
  },
  {
    id: "outreach",
    n: "05",
    tag: "Community",
    title: "Community Outreach & Engagement",
    desc: "Year-round outreach that engages residents, young people, schools, organisations and businesses.",
    image: IMG.outreach,
    body: [
      "NEAD delivers year-round outreach programmes that engage with residents, young people, schools, community organisations and businesses.",
      "These initiatives raise awareness of available opportunities, encourage volunteering, strengthen partnerships and ensure local people are actively involved in shaping projects that benefit their communities.",
    ],
  },
  {
    id: "events-development",
    n: "06",
    tag: "Partnerships",
    title: "Events & Community Development",
    desc: "Expert support for community organisations, clubs and events right across Cumbria.",
    image: IMG.otherEvents,
    body: [
      "In addition to delivering our own flagship projects, NEAD provides ongoing support to a wide range of community organisations, sporting clubs and local events across Cumbria. We work closely with Whitehaven Rugby League Football Club, Whitehaven AFC, Eat Street Cumbria and numerous other community partners.",
      "We offer event management expertise, volunteer coordination, marketing and communications, sponsorship development, funding support, operational planning and strategic guidance. By sharing our knowledge, resources and networks, we help organisations grow their impact, strengthen community engagement and deliver high-quality experiences.",
      "These partnerships reflect our commitment to collaboration, ensuring that communities across Cumbria have the support they need to thrive while creating lasting social, cultural and economic value.",
    ],
  },
  {
    id: "nead-hire",
    n: "07",
    tag: "Enterprise",
    title: "NEAD Hire",
    coming: true,
    desc: "Professional event equipment and festival support services, coming soon to Cumbria and beyond.",
    image: IMG.energyCoast,
    body: [
      "NEAD Hire is an exciting new venture that will provide professional event equipment and festival support services to organisations across Cumbria and beyond. It will offer an extensive range of high-quality equipment, including staging, event infrastructure, crowd management systems, barriers, lighting, sound, marquees, furniture and event accessories.",
      "NEAD Hire will support festivals, concerts, sporting events, community celebrations, corporate functions and private events of all sizes. Alongside equipment hire, we will provide experienced event management, operational planning, logistics and on-site support.",
      "This helps organisations deliver safe, professional and memorable events while generating sustainable income that is reinvested into NEAD's community projects and social impact initiatives.",
    ],
  },
];

export const PARTNERS = [
  "Whitehaven Rugby League FC",
  "Whitehaven AFC",
  "Eat Street Cumbria",
  "Local authorities",
  "Public sector bodies",
  "Schools & colleges",
  "Charities & third sector",
  "Community groups",
];

export const LOGOS = Array.from({ length: 22 }, (_, i) => `/logos/${i + 1}.png`);

export const GALLERIES = {
  pride: [
    IMG.pride,
    "https://images.pexels.com/photos/2306782/pexels-photo-2306782.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/15645257/pexels-photo-15645257.jpeg?auto=compress&cs=tinysrgb&w=1400",
    IMG.weekender,
  ],
  ww: [
    IMG.weekender,
    IMG.pride,
    "https://images.pexels.com/photos/32655471/pexels-photo-32655471.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/12657546/pexels-photo-12657546.jpeg?auto=compress&cs=tinysrgb&w=1400",
  ],
  ecl: [
    IMG.energyCoast,
    "https://images.pexels.com/photos/12657546/pexels-photo-12657546.jpeg?auto=compress&cs=tinysrgb&w=1400",
    "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&w=1400",
    IMG.otherEvents,
  ],
};

export const DEPARTMENTS = [
  {
    key: "leadership",
    name: "Leadership",
    blurb: "The people setting NEAD's direction, governance and strategy.",
    members: [
      { name: "Rocco Boyd", role: "Co-Chair, Events Manager & Youth Development Lead", initials: "RB", photo: "/team/rocco.jpg" },
      { name: "Glenn Anderson", role: "Co-Chair", initials: "GA", photo: "/team/glenn.jpg" },
    ],
  },
  {
    key: "festivals",
    name: "Festivals",
    blurb: "Delivering Pride by the Harbourside, the Whitehaven Weekender and Energy Coast LIVE.",
    members: [
      { name: "Rocco Boyd", role: "Events Manager", initials: "RB", photo: "/team/rocco.jpg" },
      { name: "Glenn Anderson", role: "Co-Chair", initials: "GA", photo: "/team/glenn.jpg" },
      { name: "Alan Davies", role: "Director", initials: "AD" },
      { name: "Riley Wallace", role: "RBX Consulting", initials: "RW" },
      { name: "Marc Humphries", role: "Health & Safety", initials: "MH" },
      { name: "Margaret Milne", role: "Director", initials: "MM" },
      { name: "Johnathan Elliott", role: "Cafe Team", initials: "JE" },
    ],
  },
  {
    key: "yaz",
    name: "YAZ & Youth Work",
    blurb: "Running our under-18s youth café and nightspot in Workington.",
    members: [
      { name: "Rocco Boyd", role: "Youth Development Lead", initials: "RB", photo: "/team/rocco.jpg" },
      { name: "Glenn Anderson", role: "Co-Chair", initials: "GA", photo: "/team/glenn.jpg" },
      { name: "Margaret Milne", role: "Director", initials: "MM" },
      { name: "Riley Wallace", role: "RBX Consulting", initials: "RW" },
    ],
  },
  {
    key: "edi",
    name: "EDI & Advocacy",
    blurb: "Championing equality, diversity and inclusion across everything we do.",
    members: [
      { name: "Mike Coombs", role: "Director", initials: "MC" },
      { name: "Rocco Boyd", role: "Co-Chair", initials: "RB", photo: "/team/rocco.jpg" },
      { name: "Glenn Anderson", role: "Co-Chair", initials: "GA", photo: "/team/glenn.jpg" },
    ],
  },
];

export const TEAM = [
  { name: "Glenn Anderson", role: "Co-Chair", initials: "GA", photo: "/team/glenn.jpg", featured: true, bio: "Co-Chair of NEAD CIC, setting the strategic direction and governance behind everything we deliver." },
  { name: "Rocco Boyd", role: "Co-Chair & Projects Manager", initials: "RB", photo: "/team/rocco.jpg", featured: true, bio: "Co-Chair leading on projects, partnerships and sponsorship, connecting NEAD with the organisations that help our work grow." },
  { name: "Margaret Milne", role: "Director", initials: "MM" },
  { name: "Alan Davies", role: "Director", initials: "AD" },
  { name: "Riley Wallace", role: "RBX Consulting", initials: "RW" },
  { name: "Allison Le Jurne", role: "Youth Worker", initials: "AL" },
  { name: "Johnathan Elliott", role: "Cafe Team", initials: "JE" },
  { name: "Marc Humphries", role: "Health & Safety", initials: "MH" },
];

// What NEAD sets out to achieve.
export const AIMS = [
  { n: "01", title: "Strengthen communities", body: "Deliver high-impact community programmes and public initiatives that bring people together and build stronger, more connected communities across Cumbria." },
  { n: "02", title: "Champion equality & inclusion", body: "As Northern Equality and Diversity, we remove barriers to participation and celebrate the full diversity of our region, from Pride by the Harbourside to everyday outreach." },
  { n: "03", title: "Support young people", body: "Run Cumbria's first dedicated under-18s social venue and create real pathways into learning, volunteering and employment for the next generation." },
  { n: "04", title: "Celebrate culture, music & festivals", body: "Produce landmark festivals and live music events, and through NEAD Hire, provide the staging, equipment and expertise to power other organisations' events too." },
  { n: "05", title: "Reinvest for lasting value", body: "Operate as a purpose-driven CIC where every surplus is reinvested into our community objectives, so the value we create endures well beyond any single project." },
];
